import { defineRule } from 'vee-validate';
import { required, email, min } from '@vee-validate/rules';

defineRule('required', required);
defineRule('email', email);
defineRule('min', min);

function getValueByPath(obj, path) {
  if (path == null || path === '') return undefined;
  const keys = path.split('.');
  let value = obj;
  for (const key of keys) {
    value = value != null ? value[key] : undefined;
  }
  return value;
}

export async function validateLegacy(schema, form) {
  const errors = {};

  for (const field in schema) {
    const config = schema[field];

    let rules = '';
    let label = field;

    if (typeof config === 'string') {
      rules = config;
    } else {
      rules = config.rules || '';
      label = config.label || field;
    }

    const value =
      field.indexOf('.') !== -1 ? getValueByPath(form, field) : form[field];

    const ruleList = rules.split('|');

    for (const rule of ruleList) {
      if (rule === 'required') {
        const isEmpty =
          value === null ||
          value === undefined ||
          value === '' ||
          (Array.isArray(value) && value.length === 0) ||
          (typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value) &&
            value.id == null &&
            value.value == null);
        if (isEmpty) {
          errors[field] = `${label} é obrigatório`;
          break;
        }
      }

      if (rule === 'email') {
        const emailRegex = /\S+@\S+\.\S+/;

        if (value && !emailRegex.test(value)) {
          errors[field] = `${label} deve ser um email válido`;
          break;
        }
      }

      if (rule.startsWith('min')) {
        const minVal = Number(rule.split(':')[1]);

        if (minVal < 1) {
          let num = null;
          if (value == null || value === '') {
            num = 0;
          } else if (typeof value === 'number' && !Number.isNaN(value)) {
            num = value;
          } else if (typeof value === 'string') {
            const cleaned = value
              .replace(/\s/g, '')
              .replace(/R\$\s?/i, '')
              .replace(/\./g, '')
              .replace(',', '.');
            num = parseFloat(cleaned);
            if (Number.isNaN(num)) num = 0;
          }
          if (num !== null && num < minVal) {
            errors[field] = `${label} deve ser no mínimo ${minVal}`;
            break;
          }
        } else if (value && value.length < minVal) {
          errors[field] = `${label} deve ter no mínimo ${minVal} caracteres`;
          break;
        }
      }

      if (rule.startsWith('max')) {
        const max = Number(rule.split(':')[1]);

        if (value && value.length > max) {
          errors[field] = `${label} deve ter no máximo ${max} caracteres`;
          break;
        }
      }
    }
  }

  return errors;
}
